import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'modaldesign',
  templateUrl: './modaldesign.component.html',
  styleUrls: ['./modaldesign.component.scss']
})
export class ModaldesignComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
